import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-[25rem] py-2" }
const _hoisted_2 = { class: "m-0 flex h-14 min-w-14 items-center justify-center rounded-xl bg-background-normal" }
const _hoisted_3 = { class: "flex flex-col items-start gap-1" }
const _hoisted_4 = { class: "flex text-sm font-normal text-[#1F2937]" }
const _hoisted_5 = { class: "flex justify-center p-2.5" }

import { computed } from 'vue'
import i18n from '@/scripts/app-configs/i18n-config'
import { ICONS } from '@/components/drawers/MemberDrawer/constants/member-goals-icons'
import type { Goal } from '@/components/drawers/MemberDrawer/types/member-drawer.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDrawerContentPatientGoals',
  props: {
    items: { default: () => [] }
  },
  emits: ["copy-to-clipboard"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const orderedItems = computed(() => {
  return props.items.toSorted((a, b) => ((a.is_achieved === b.is_achieved) ? 0 : a.is_achieved ? -1 : 1))
})

const buttonLabel = computed(() => {
  const total = props.items.length
  const achieved = props.items.filter((item) => item.is_achieved).length

  if (!total) return i18n.t('SIDEBAR.GOALS_NONE')
  if (total === 1) return i18n.t('SIDEBAR.GOALS_VIEW_SINGULAR', { achieved })

  return i18n.t('SIDEBAR.GOALS_VIEW_PLURAL', { achieved, total })
})

const translateGoal = ({ key, value }: { key: string, value: string | number }) => {
  return i18n.t(`personal_goal_${key}`, { value })
}

const handleCopyGoals = () => {
  const output = orderedItems.value.map((goal) => `• ${translateGoal(goal)}`).join('\n')

  emit('copy-to-clipboard', output)
}

const getIconPath = (key: string) => {
  const icon = ICONS[key as keyof typeof ICONS] ?? 'goal'

  return require(`@ui-kit/assets/images/goals/${icon}.svg`)
}

return (_ctx: any,_cache: any) => {
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_goal_status_pill = _resolveComponent("goal-status-pill")!
  const _component_sword_popover_wuk = _resolveComponent("sword-popover-wuk")!
  const _directive_close_popper = _resolveDirective("close-popper")!

  return (_openBlock(), _createBlock(_component_sword_popover_wuk, {
    class: "relative ml-2 inline-block",
    distance: 10,
    placement: "bottom-end"
  }, {
    content: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: index,
            class: "flex gap-4 border-b border-background-dark px-4 py-3 last:border-b-0"
          }, [
            _createElementVNode("figure", _hoisted_2, [
              _createVNode(_component_inline_svg, {
                src: getIconPath(item.key),
                class: "size-8"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h6", _hoisted_4, _toDisplayString(translateGoal(item)), 1),
              _createVNode(_component_goal_status_pill, {
                status: item.is_achieved ? 'achieved' : 'not_achieved'
              }, null, 8, ["status"])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_sword_button_wuk, {
            theme: "secondary",
            icon: "copy",
            size: "small",
            side: "left",
            text: __props.items.length > 1 ? _ctx.$t('SIDEBAR.GOALS_COPY_ALL') : _ctx.$t('SIDEBAR.GOALS_COPY_1'),
            class: "w-full",
            onClickNative: handleCopyGoals
          }, null, 8, ["text"]), [
            [_directive_close_popper]
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_sword_button_wuk, {
        theme: "secondary",
        icon: "target-arrow",
        size: "small",
        side: "left",
        text: buttonLabel.value,
        disabled: !__props.items.length,
        class: "!mt-2"
      }, null, 8, ["text", "disabled"])
    ], undefined, true),
    _: 1
  }))
}
}

})